<template>
  <Breadcrumbs
      title="Review Dealer"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealers', path: '/dealers' },
      { label: 'Review Dealer', path: '/review-dealer' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <reviewDealerForm/>
    </div>
  </div>
</template>

<script>

import reviewDealerForm from "@/pages/master_data/dealers/reviewDealerForm.vue";

export default {
  components: {
    reviewDealerForm
  }
}

</script>